import React from "react";

const AddTagToSectionForm = ({
  sections,
  tags,
  selectedSectionIdForTag,
  setSelectedSectionIdForTag,
  selectedTagId,
  setSelectedTagId,
  sectionTagOrder,
  setSectionTagOrder,
  onSubmit,
}) => {
  return (
    <div className="pb-wide">
      <div className="pb-card">
        <h2>Add Tag to Section (Optional)</h2>

        <form onSubmit={onSubmit} className="pb-row-form">
          <div className="pb-col">
            <label className="pb-label">Section</label>
            <select
              className="pb-select"
              value={selectedSectionIdForTag}
              onChange={(e) => setSelectedSectionIdForTag(e.target.value)}
            >
              <option value="">-- select section --</option>
              {sections.map((s) => (
                <option key={s.id} value={s.id}>
                  {s.title} ({s.mode})
                </option>
              ))}
            </select>
          </div>

          <div className="pb-col">
            <label className="pb-label">Tag</label>
            <select
              className="pb-select"
              value={selectedTagId}
              onChange={(e) => setSelectedTagId(e.target.value)}
            >
              <option value="">-- select tag --</option>
              {tags.map((t) => (
                <option key={t.id} value={t.id}>
                  {t.name}
                </option>
              ))}
            </select>
          </div>

          <div className="pb-col">
            <label className="pb-label">Order</label>
            <input
              className="pb-input"
              type="number"
              value={sectionTagOrder}
              onChange={(e) => setSectionTagOrder(Number(e.target.value))}
            />
          </div>

          <div className="pb-col pb-col-btn">
            <button className="pb-button" type="submit">
              Add Tag
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddTagToSectionForm;